export * from './patients/types';

export const KEY = 'COVID';
export interface CovidScreeningState {
  patient: Patient;
  subscriber: Subscriber;
  questionnaire: Questionnaire;
  insuranceCard?: InsuranceCard[] | null;
  insuranceList: InsuranceList;
  prevPatient: Patient;
  isOTPValidated: boolean;
}
export interface Patient {
  dateOfBirth: string;
  cmrn: string;
  icentraPersonId: string;
  ssn?: string;
  genderType: 'MALE' | 'FEMALE' | 'BOTH' | 'UNKNOWN' | '';
  names?: NamesEntity[] | null;
  addresses?: AddressesEntity[] | null;
  phones?: PhonesEntity[] | null;
  emails?: EmailsEntity[] | null;
  relationship?: string | null;
  userHasNoCellNumber?: boolean;
}
export interface NamesEntity {
  givenName: string;
  familyName: string;
  middleName: string;
}
export interface AddressesEntity {
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip: string;
  type: string;
}
export interface PhonesEntity {
  areaCode: string;
  phoneNumber: string;
  countryCode: string | null;
  phoneType: string;
}
export interface EmailsEntity {
  address: string;
  type: string;
}
export interface Subscriber {
  subscriber_first_name: string;
  subscriber_last_name: string;
  subscriber_dob: string;
  subscriber_sex: string;
  subscriber_phone: string;
  subscriber_address_1: string;
  subscriber_address_2: string;
  subscriber_city: string;
  subscriber_state: string;
  subscriber_zip_code: string;
  subscriber_email: string;
  SUBSCRIBER_FIRST_NAME_ON_CARD: string;
  SUBSCRIBER_MIDDLE_NAME_ON_CARD: string;
  SUBSCRIBER_LAST_NAME_ON_CARD: string;
  MEMBER_NUMBER: string;
  GROUP_NUMBER: string;
  ResponseId: string;
}

export interface Questionnaire {
  Q_Fever: string;
  Q_New_or_Worsening_Cough: string;
  Q_Shortness_of_Breath_New_or_Worsening: string;
  Q_Body_Aches: string;
  Q_COVID_Screen_Sore_Throat: string;
  Q_COVID_Screen_Runny_Nose: string;
  Q_COVID_Screen_Decreased_Smell_or_Taste: string;
  Q_Diarrhea: string;
  Q_Outbreak_Date_of_Symptoms_Onset: string;
  Q_COVID_Healthcare_Worker_HD_residence: string;
  Q_Covid19_Prescreening: string;
  Q_Covid19_Prescreening_Work?: string;
  Q_Covid19_Prescreening_Travel?: string;
  Q_Covid_Symptoms_Primary: string;
  has_insurance: string;
  have_been_patient: string;
  have_changed_insurance: string;
  Q_attest_to_accurate_and_complete: string;
  Q_COVID_Screen_High_Density_Residence: string;
  Q_COVID_Screen_Close_Contact: string;
  Q_UDOH_Contact_Tracing: string;
  Q_Patient_relationship_to_subscriber: string;
  Q_None_of_the_above: string;
  HealthPlan_state: string;
  HealthPlan_zip_code: string;
  HealthPlan_City: string;
  Health_Plan_ID: string;
  Health_Plan_Name: string;
  Health_Plan_Address_line_1: string;
  Health_Plan_Address_line_2: string;
  HEALTH_PLAN_COUNTRY: string;
}
export interface InsuranceCard {
  img: string;
  mimeType: string;
  fileName: string;
  fileString: string;
}

export interface InsuranceList {
  isFetching: boolean;
  insuranceData: InsuranceCardData[];
  error: boolean;
}
export interface InsuranceCardData {
  city: string;
  country: string;
  health_plan_id: string;
  plan_name: string;
  state: string;
  street_address: string;
  zipcode: string;
}
export interface OrderStatus {
  orderStatus: number;
}

export interface Consumer {
  cernerPersonId?: string;
  consumerId: string;
  pingUserId: string;
  umpiLinkId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  displayName?: string;
  givenName: string;
  dateOfBirth: string;
  emails: Email[];
  phones: Phone[];
  addresses: Address[];
  age: number;
  emancipatedMinor: boolean;
  ethnicity?: string;
  gender?: 'Female' | 'Male' | 'Other' | 'Prefer not to respond';
  mrn?: string;
  userName?: string;
  shSubscriberNumber?: string;
  ssn?: string;
  externalTermsAcceptance: TermAcceptance[];
  termAcceptance: TermAcceptance;
  doOnboarding: boolean;
  appCacheKey: string;
  newAppCacheKey: string;
  isInMillenium?: boolean;
}

export interface FormValues {
  userFirstName: string;
  userMiddleName: string;
  userLastName: string;
  userDateOfBirth: string;
  userSSNDigits: number;
  userSex: string;
  userAddressLine1: string;
  userAddressLine2: string;
  userCity: string;
  userState: string;
  userZip: number;
  userEmail: string;
  userCellNumber: string;
  userOtherPhoneNumber: string;
  userHasNoCellNumber?: boolean;
}
